import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import {
  formatCpfCnpj,
  formatDocumentTypeName,
  formatPersonTypeName,
  formatUpperCase,
  formatPercentage,
} from "../../../../utils/formats";

const DadosGeraisPropostaSection = (props) => {
  const {
    color = "#fff",
    proposalCompleteRegistrationLoading,
    proposalOperationLoading,
    numeroCpfCnpj,
    nomeCliente,
    tipoPessoa,
    nomeConvenio,
    nomeFilial,
    nomeAnalista,
    nomeFilialFantasia,
    numeroProposta,
    produto,
    descricaoStatus,
    rankingRelacionamento,
    sistemaOrigem,
    pcLtvRisco,
    pcCompRendaCliente,
    idRiscoScrCliente,
    idRiscoSerasaCliente,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            color={color}
            label={formatDocumentTypeName(numeroCpfCnpj)}
            value={formatCpfCnpj(numeroCpfCnpj)}
          />
        </Grid>
        <Grid item md={8}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            color={color}
            label={formatPersonTypeName(numeroCpfCnpj)}
            value={nomeCliente}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            color={color}
            label="Número da proposta"
            value={numeroProposta}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalOperationLoading}
            color={color}
            label="Produto"
            value={produto}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            color={color}
            label="Convênio"
            value={nomeConvenio}
          />
        </Grid>
        <Grid item md={8}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            color={color}
            label="Filial (loja)"
            value={nomeFilial}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            color={color}
            label="Nome fantasia"
            value={nomeFilialFantasia}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Analista"
            value={formatUpperCase(nomeAnalista)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Status"
            value={formatUpperCase(descricaoStatus)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Ranking Relacionamento"
            value={formatUpperCase(rankingRelacionamento)}
          />
        </Grid>
        {sistemaOrigem && (
          <Grid item md={3}>
            <Input
              loading={proposalCompleteRegistrationLoading}
              label="Origem"
              value={sistemaOrigem}
            />
          </Grid>
        )}
        {pcLtvRisco != null && (
          <Grid item md={3}>
            <Input
              loading={proposalCompleteRegistrationLoading}
              label="LTV de Risco"
              value={formatPercentage(pcLtvRisco)}
            />
          </Grid>
        )}
        {pcCompRendaCliente != null && (
          <Grid item md={3}>
            <Input
              loading={proposalCompleteRegistrationLoading}
              label="Comp. Renda (cliente)"
              value={formatPercentage(pcCompRendaCliente)}
            />
          </Grid>
        )}
        {idRiscoScrCliente != null && (
          <Grid item md={3}>
            <Input
              loading={proposalCompleteRegistrationLoading}
              label="Risco SCR (cliente)"
              value={formatUpperCase(idRiscoScrCliente)}
            />
          </Grid>
        )}
        {idRiscoSerasaCliente != null && (
          <Grid item md={3}>
            <Input
              loading={proposalCompleteRegistrationLoading}
              label="Risco Serasa (cliente)"
              value={formatUpperCase(idRiscoSerasaCliente)}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default DadosGeraisPropostaSection;
